import axios from "../http_v2";

export default {
  list(params) {
    return axios.get("cmsservice/cms_product/page", params);
  },
  listAll(params) {
    return axios.get("cmsservice/cms_product/page/share", params);
  },
  info(id) {
    return axios.get("cmsservice/cms_product/info/" + id, {});
  },
  add(params) {
    return axios.post("cmsservice/cms_product/add", params);
  },
  update(params) {
    return axios.post("cmsservice/cms_product/update", params);
  },
  del(params) {
    return axios.post("cmsservice/cms_product/delete", params);
  },
  //上架下架
  status(params) {
    return axios.get("cmsservice/cms_product/status", params);
  },
  //产品置顶
  top(params) {
    return axios.get("cmsservice/cms_product/top", params);
  },
  type: {
    tree(params) {
      return axios.get("cmsservice/productSort/tree", params);
    },
    add(params) {
      return axios.post("cmsservice/productSort/add", params);
    },
    update(params) {
      return axios.put("cmsservice/productSort/update", params);
    },
    del(id) {
      return axios.delete("cmsservice/productSort/del/" + id, {});
    },
  },
  op: {
    //获取产品
    list(params) {
      return axios.get("cmsservice/productSort/op/tree", params);
    },
  },
};
